var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LinkComponent } from "../../Atoms";
import { ElementType } from "../../../types";
var Element = function (props) {
    var attributes = props.attributes, children = props.children, element = props.element;
    var style = { textAlign: (element === null || element === void 0 ? void 0 : element.align) || "left" };
    switch (element.type) {
        case ElementType.BlockQuote:
            return (_jsx("blockquote", __assign({ style: style }, attributes, { children: children })));
        case ElementType.BulletedList:
            return (_jsx("ul", __assign({ style: style }, attributes, { children: children })));
        case ElementType.HeadingOne:
            return (_jsx("h1", __assign({ style: style }, attributes, { children: children })));
        case ElementType.HeadingTwo:
            return (_jsx("h2", __assign({ style: style }, attributes, { children: children })));
        case ElementType.ListItem:
            return (_jsx("li", __assign({ style: style }, attributes, { children: children })));
        case ElementType.NumberedList:
            return (_jsx("ol", __assign({ style: style }, attributes, { children: children })));
        case ElementType.Link:
            return _jsx(LinkComponent, __assign({}, props));
        case ElementType.Paragraph:
            return (_jsx("div", __assign({ style: style }, attributes, { children: children })));
        default:
            return (_jsx("span", __assign({ style: style }, attributes, { children: children })));
    }
};
export default Element;
